import "./DashboardTableCard.css";

import { SortColumn } from "react-data-grid";
import { useNavigate } from "react-router-dom";

import { ArrowheadRightDarkIcon } from "../../../../../assets";
import { SelectData } from "../../../../../models";
import { ResultData } from "../../../../../service/Shared";
import {
  Button,
  Card,
  Column,
  CursorDataGrid,
  DataGridColumnDefinition,
  DataGridCursorDataLoadEventHandler,
  Row,
  Select,
} from "../../../../../widget";

export interface DashboardTableCardProps {
  data?: ResultData[];
  columns: DataGridColumnDefinition[];
  title: string;
  expandRoute?: string;
  height?: number;
  isLoading: boolean;
  selectedPipeline: string;
  pipelinesData: SelectData;
  refresh: boolean;
  defaultSortingCriteria: SortColumn[];
  onChangePipelines: (pipeline: string) => void;
  onChange?: DataGridCursorDataLoadEventHandler;
}

export const DashboardTableCard = ({
  data,
  columns,
  title,
  expandRoute,
  height,
  isLoading,
  selectedPipeline,
  pipelinesData,
  refresh,
  defaultSortingCriteria,
  onChangePipelines,
  onChange,
}: DashboardTableCardProps): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Card height={height} corners="rounded" padding="l">
      <Row justify="between" align="center" spacingV="l">
        <Column span={4}>
          <h2>{title}</h2>
        </Column>
        <Column span={4} justify="end" hasNoPadding>
          <div className="DashboardTableCardButtons">
            {pipelinesData.length > 1 && (
              <div className="Pipeline">
                <p className="body2">Pipeline</p>
                <Select
                  data={pipelinesData}
                  value={selectedPipeline}
                  onChange={onChangePipelines}
                  corners="rounded"
                  size="small"
                  fontSize="body2"
                />
              </div>
            )}
            <Button
              onClick={expandRoute ? () => navigate(expandRoute) : undefined}
              text="View all"
              icon={<ArrowheadRightDarkIcon />}
              variant="reversedPrimary"
              size="small"
              hasNoPadding
              // minWidth={false}
            />
          </div>
        </Column>
      </Row>
      <Row>
        <Column span={12} className="DashboardTableCardDataGrid">
          <CursorDataGrid
            data={data || []}
            onChange={onChange}
            columns={columns}
            clientSide={onChange === undefined}
            pageable={false}
            sortable
            filterable
            pagination={{ totalCount: data?.length || 0 }}
            dataIsLoading={isLoading}
            noDataMessage="No deals to display"
            variant="seed"
            showTotalCount={false}
            refresh={refresh}
            defaultSortingCriteria={defaultSortingCriteria}
          />
        </Column>
      </Row>
    </Card>
  );
};
